<div class="table-responsive margin-top-15 table-view">
  <h5 class="table-title">Observation By Observer</h5>
  <button [disabled]="DisableExport"
    class="btn btn-primary primary-btn button-excel"
    style="margin-bottom: 10px"
    (click)="exportToExcel()"
  >
    <i class="fa fa-file-excel-o"></i>Export To Excel
  </button>
  <p-table
    [value]="ObservationByObserverData"
    dataKey="Id"
    editMode="row"
    id="ObservationByObserverTableToExport"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 150px">Unit/ Department</th>
        <th style="width: 170px">Full Name</th>
        <th class="center-table" style="width: 80px">Jan</th>
        <th class="center-table" style="width: 80px">Feb</th>
        <th class="center-table" style="width: 80px">Mar</th>
        <th class="center-table" style="width: 80px">Apr</th>
        <th class="center-table" style="width: 80px">May</th>
        <th class="center-table" style="width: 80px">Jun</th>
        <th class="center-table" style="width: 80px">Jul</th>
        <th class="center-table" style="width: 80px">Aug</th>
        <th class="center-table" style="width: 80px">Sep</th>
        <th class="center-table" style="width: 80px">Oct</th>
        <th class="center-table" style="width: 80px">Nov</th>
        <th class="center-table" style="width: 80px">Dec</th>
        <th class="center-table" style="width: 100px">Total</th>
        <th class="center-table" style="width: 100px">Actions</th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-observationByObserver
      let-editing="editing"
      let-rowIndex="rowIndex"
    >
      <tr style="width: 150px" [pEditableRow]="observationByObserver">
        <td
          *ngIf="
            rowGroupMetadata[observationByObserver.BaseUnit].index === rowIndex
          "
          [attr.rowspan]="rowGroupMetadata[observationByObserver.BaseUnit].size"
        >
          <span class="p-text-bold p-ml-2">{{
            observationByObserver.BaseUnit
          }}</span>
        </td>
        <td style="width: 150px">
          {{ observationByObserver.FullName }}
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="observationByObserver.Jan"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetObsByObserverSelectedDetails(
                    observationByObserver.UnitId,
                    observationByObserver.BaseUnit,
                    1,
                    observationByObserver.User
                  )
                "
                data-target="#AT"
              >
                {{ observationByObserver.Jan }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="observationByObserver.Feb"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetObsByObserverSelectedDetails(
                    observationByObserver.UnitId,
                    observationByObserver.BaseUnit,
                    2,
                    observationByObserver.User
                  )
                "
                data-target="#AT"
              >
                {{ observationByObserver.Feb }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="observationByObserver.Mar"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetObsByObserverSelectedDetails(
                    observationByObserver.UnitId,
                    observationByObserver.BaseUnit,
                    3,
                    observationByObserver.User
                  )
                "
                data-target="#AT"
              >
                {{ observationByObserver.Mar }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="observationByObserver.Apr"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetObsByObserverSelectedDetails(
                    observationByObserver.UnitId,
                    observationByObserver.BaseUnit,
                    4,
                    observationByObserver.User
                  )
                "
                data-target="#AT"
              >
                {{ observationByObserver.Apr }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="observationByObserver.May"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetObsByObserverSelectedDetails(
                    observationByObserver.UnitId,
                    observationByObserver.BaseUnit,
                    5,
                    observationByObserver.User
                  )
                "
                data-target="#AT"
              >
                {{ observationByObserver.May }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="observationByObserver.Jun"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetObsByObserverSelectedDetails(
                    observationByObserver.UnitId,
                    observationByObserver.BaseUnit,
                    6,
                    observationByObserver.User
                  )
                "
                data-target="#AT"
              >
                {{ observationByObserver.Jun }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="observationByObserver.Jul"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetObsByObserverSelectedDetails(
                    observationByObserver.UnitId,
                    observationByObserver.BaseUnit,
                    7,
                    observationByObserver.User
                  )
                "
                data-target="#AT"
              >
                {{ observationByObserver.Jul }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="observationByObserver.Aug"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetObsByObserverSelectedDetails(
                    observationByObserver.UnitId,
                    observationByObserver.BaseUnit,
                    8,
                    observationByObserver.User
                  )
                "
                data-target="#AT"
              >
                {{ observationByObserver.Aug }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="observationByObserver.Sep"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetObsByObserverSelectedDetails(
                    observationByObserver.UnitId,
                    observationByObserver.BaseUnit,
                    9,
                    observationByObserver.User
                  )
                "
                data-target="#AT"
              >
                {{ observationByObserver.Sep }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="observationByObserver.Oct"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetObsByObserverSelectedDetails(
                    observationByObserver.UnitId,
                    observationByObserver.BaseUnit,
                    10,
                    observationByObserver.User
                  )
                "
                data-target="#AT"
              >
                {{ observationByObserver.Oct }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="observationByObserver.Nov"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetObsByObserverSelectedDetails(
                    observationByObserver.UnitId,
                    observationByObserver.BaseUnit,
                    11,
                    observationByObserver.User
                  )
                "
                data-target="#AT"
              >
                {{ observationByObserver.Nov }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="observationByObserver.Dec"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetObsByObserverSelectedDetails(
                    observationByObserver.UnitId,
                    observationByObserver.BaseUnit,
                    12,
                    observationByObserver.User
                  )
                "
                data-target="#AT"
              >
                {{ observationByObserver.Dec }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="observationByObserver.Total"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetObsByObserverSelectedDetails(
                    observationByObserver.UnitId,
                    observationByObserver.BaseUnit,
                    13,
                    observationByObserver.User
                  )
                "
                data-target="#AT"
              >
                {{ observationByObserver.Total }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td style="text-align: center">
          <button
            *ngIf="!editing"
            pButton
            pRipple
            type="button"
            pInitEditableRow
            icon="pi pi-pencil"
            (click)="onRowEditInit(observationByObserver)"
            class="p-button-rounded p-button-text"
          ></button>
          <button
            *ngIf="editing"
            pButton
            pRipple
            type="button"
            pSaveEditableRow
            icon="pi pi-check"
            (click)="onRowEditSave(observationByObserver, rowIndex)"
            class="p-button-rounded p-button-text p-button-success p-mr-2"
          ></button>
          <button
            *ngIf="editing"
            pButton
            pRipple
            type="button"
            pCancelEditableRow
            icon="pi pi-times"
            (click)="onRowEditCancel(observationByObserver, rowIndex)"
            class="p-button-rounded p-button-text p-button-danger"
          ></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<div
  class="modal fade PDModal"
  data-backdrop="static"
  style="opacity: 1 !important"
  id="AT"
  role="dialog"
>
  <div class="modal-dialog custom-modal">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close button-cancel" data-dismiss="modal">
          &times;
        </button>
        <!-- <h4 class="modal-title custom_align" id="Heading">Risk Assessment Matrix</h4> -->
      </div>
      <div class="modal-body">
        <!-- <img class="ram-img" src="assets/images/incident-ram.png" /> -->
        <ol id="liPDheight">
          <ng-container *ngFor="let item of ObsByObserverData; let i = index">
            <li>
              <a (click)="Redirect(item.value, item.ID)">{{ item.Text }}</a>
            </li>
          </ng-container>
        </ol>
        <span *ngIf="ObsByObserverData?.length < 1" style="color: red"
          >No Records Found..</span
        >
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</div>
